import styled from "styled-components";

export default styled.button`
  background-color: white;
  border: 1px solid #777;
  padding: 10px 16px;
  border-radius: 5px;
  font-size: 15px;
  cursor: pointer;
  :hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;
